import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../pipes/pipes.module';
import { FormsModule } from '@angular/forms';
import { QuestionAnswerComponent } from './question-answer.component';

@NgModule({
  declarations: [
    QuestionAnswerComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    PipesModule
  ],
  exports: [
    QuestionAnswerComponent
  ]
})
export class QuestionAnswerModule { }
